import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    link: {
      height: '80px',
      width: '100%',
      minWidth: 'auto !important',
      userSelect: 'none',
    },
    buttonText: {
      fontSize: '16px',
    },
  }),
  { name: 'CtaItem' },
);

export default useStyles;
